// Info-status, Approved
export default function hasLoanApp({ to, next, store }) {
	const { loanStatus } = store.state.centrifugeStatus;

	if (loanStatus !== 'approved' && to.name === 'approved') {
		return next({ name: 'home' });
	}

	const ignoredStatuses = ['created', 'closed', 'closed.without_verification'];

	if (!loanStatus || ignoredStatuses.includes(loanStatus)) {
		return next({ name: 'home' });
	}

	return next();
}
